import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/material';

import { FormattedMessage } from 'react-intl';

import LoopIcon from '@mui/icons-material/Loop';

const JEError = ({ masterDetailView = false }) => {
  const { labelOptions } = useTheme();

  return (
    <Box sx={{ textAlign: 'center', maxWidth: 800, py: 2, px: 4, margin: 'auto', whiteSpace: 'normal' }}>
      <Typography variant="h4" mb={1}>
        <FormattedMessage id="document.journalEntry.error.title" defaultMessage="Something went wrong" />
      </Typography>

      <Box>
        {!masterDetailView ? (
          <FormattedMessage
            id="document.journalEntry.error.message"
            defaultMessage="The data entry form is not available due to a connectivity or other issue.
          Please, click {sync} button at the top-right of the screen  or contact {email}"
            values={{
              sync: (
                <Typography
                  component="span"
                  sx={{ color: 'primary.main', display: 'inline-flex', alignItems: 'center' }}
                >
                  Sync <LoopIcon />
                </Typography>
              ),
              email: (
                <Link underline="hover" href={`mailto:${labelOptions.supportEmail}`}>
                  {labelOptions.supportEmail}
                </Link>
              ),
            }}
          />
        ) : (
          <FormattedMessage
            id="document.journalEntry.error.shortMessage"
            defaultMessage="The data entry form is not available due to a connectivity or other issue."
          />
        )}
      </Box>
    </Box>
  );
};

export default JEError;
